// constant addition
export default Object.freeze({
  ...process.env,
  SAMPLE_TEST: '',
  ONETIMEKEY_LENGTH: 200,
});



// WEBPACK FOOTER //
// ./src/constants/index.js